module.exports = __webpack_public_path__ + "media/images/services-efd0ebb9a87668747780763db832eb0f.jpg";